import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '@shared/models/request-state';
import { ApiCacheService } from '@shared/services/api-cache.service';
import { ActivityResponse } from '@calendar/models/response/activity.response';

@Injectable({
  providedIn: 'root',
})
export class HiTextService {
  private readonly _url = `${environment.apiUrl}Activity/`;

  constructor(private cacheService: ApiCacheService) {}

  getActivity(type: 'hi1' | 'hi2'): Observable<RequestState<ActivityResponse>> {
    const cacheId = `activity-${type}`;
    const url = `${this._url}${type}`;
    return this.cacheService.request<ActivityResponse>(cacheId, url);
  }

  refreshActivity(
    type: 'hi1' | 'hi2'
  ): Observable<RequestState<ActivityResponse>> {
    const cacheId = `activity-${type}`;
    const url = `${this._url}${type}`;
    return this.cacheService.forceRefreshGet<ActivityResponse>(cacheId, url);
  }
}
